import { connect } from 'react-redux';
import { getDisplayLevel } from '../../../helpers/getLevelHelper';
import { getCurrentLevel } from '../KYC_IMLegacyHelpers';
import KYC_IMLegacyFormComponent from './KYC_IMLegacyFormComponent';
import { kycLevelFormSelector } from '../../../redux/selectors/kycLevelsSelectors';
import { getFormValues, reduxForm, reset as _reset } from 'redux-form';
import { confirmMitek, validateUserRegistrationIdentityMind, validateUserRegistrationMitek } from '../../../redux/actions/kycIdentityMindActions';
import { logout as _logout } from '../../../redux/actions/authActions';
var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = kycLevelFormSelector(state),
    verificationLevel = _kycLevelFormSelector.verificationLevel,
    kycConfig = _kycLevelFormSelector.kycConfig,
    kyc = _kycLevelFormSelector.kyc,
    alphaPointSessiontoken = _kycLevelFormSelector.alphaPointSessiontoken,
    alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
    userConfig = _kycLevelFormSelector.userConfig,
    userName = _kycLevelFormSelector.userName,
    email = _kycLevelFormSelector.email,
    processing = _kycLevelFormSelector.processing,
    levelIncreaseStatus = _kycLevelFormSelector.levelIncreaseStatus;
  var level = getDisplayLevel(kycConfig, getCurrentLevel(verificationLevel, levelIncreaseStatus));
  return {
    level: level,
    processing: processing,
    formValues: getFormValues('KYCIMLegacyForm')(state),
    // Used in KYCMitekComponent
    alphaPointUserID: alphaPointUserID,
    alphaPointSessiontoken: alphaPointSessiontoken,
    kycConfig: kycConfig,
    userName: userName,
    kyc: kyc,
    userConfig: userConfig,
    // Submit IM helper
    email: email
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    // Used in KYCMitekComponent
    confirmInfoMitek: function confirmInfoMitek(setUserConfigPayload) {
      return dispatch(confirmMitek(setUserConfigPayload));
    },
    launchMitek: function launchMitek(payload) {
      return dispatch(validateUserRegistrationMitek(payload));
    },
    // Submit IM helper
    submitInfoIdentityMind: function submitInfoIdentityMind(payload) {
      return dispatch(validateUserRegistrationIdentityMind(payload));
    },
    reset: function reset() {
      return dispatch(_reset('KYCIMLegacyForm'));
    },
    logout: function logout() {
      return dispatch(_logout());
    }
  };
};
var KYC_IMLegacyForm = reduxForm({
  form: 'KYCIMLegacyForm',
  onSubmit: function onSubmit() {}
})(KYC_IMLegacyFormComponent);
export default connect(mapStateToProps, mapDispatchToProps)(KYC_IMLegacyForm);